module.exports = __webpack_public_path__ + "MX.png?5ced984b33847bfdde3d231643df4c00";